import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Box from "@mui/material/Box";
import Colors from "./Colors";

export default function ColorSelect(props) {
  const [selectedColor, setSelectedColor] = React.useState(props.initialColor || "none");

  React.useEffect(() => {
    setSelectedColor(props.initialColor || "none");
  }, [props.initialColor]);

  const handleClose = () => {
    props.onClose();
  };

  const handleSave = () => {
    props.onSave(selectedColor);
    handleClose();
  };

  return (
    <Menu
      anchorEl={props.anchorEl}
      open={props.open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      PaperProps={{
        sx: {
          p: 2,
          backgroundColor: "#000000dd",
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Colors color={selectedColor} setColor={setSelectedColor} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Box>
    </Menu>
  );
}
